import { useState } from "react";
import { ChevronDown, ChevronRight, Table } from "lucide-react";

const ReferenceTable = () => {
  const [openSections, setOpenSections] = useState(false);

  const toggleSection = () => {
    setOpenSections((prev) => !prev);
  };

  const emissionData = [
    {
      fuelType: "HFO",
      CO2: 3.114,
      CH4: 0.00005,
      N2O: 0.00018,
      CO2Equivalent: 3.115,
      GHG: 3.115,
      SOX: "0.085 × S",
      NOX: 0.087,
      PM: 0.0045,
    },
    {
      fuelType: "LFO",
      CO2: 3.151,
      CH4: 0.00005,
      N2O: 0.00018,
      CO2Equivalent: 3.152,
      GHG: 3.152,
      SOX: "0.085 × S",
      NOX: 0.082,
      PM: 0.002,
    },
    {
      fuelType: "MGO",
      CO2: 3.206,
      CH4: 0.00005,
      N2O: 0.00018,
      CO2Equivalent: 3.207,
      GHG: 3.207,
      SOX: "0.085 × S",
      NOX: 0.081,
      PM: 0.0015,
    },
  ];

  const headers = [
    "Fuel Type",
    "CO₂ (kg/kg)",
    "CH₄ (kg/kg)",
    "N₂O (kg/kg)",
    "CO₂ Equivalent (kg/kg)",
    "GHG Emission (kg/kg)",
    "SOₓ (kg/kg)",
    "NOₓ (kg/kg)",
    "PM (kg/kg)",
  ];

  return (
    <div>
      {/* Fleet Emission Analytics Accordion */}
      <div className="mb-6 border border-gray-300 rounded-lg overflow-hidden">
        <button
          className="flex items-center justify-between w-full p-5 bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={toggleSection}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-[#cde7f7] rounded-lg">
              <Table className="w-6 h-6 text-[#1a5276]" />
            </div>
            <div className="text-left">
              <h2 className="text-md font-bold text-gray-800">
                Reference Table
              </h2>
              <p className="text-gray-600 text-sm">Emission Factors</p>
            </div>
          </div>
          {openSections ? (
            <ChevronDown className="w-5 h-5 text-gray-500" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-500" />
          )}
        </button>

        {openSections && (
          <div className="p-5 bg-white border-t border-gray-200">
            <div className="overflow-x-auto">
              <table className="w-full min-w-full border-collapse">
                <thead>
                  <tr className="bg-gray-50">
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        className="px-4 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider border-b border-gray-200"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {emissionData.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-6 py-4 text-sm font-semibold text-gray-900 border-r border-gray-100 last:border-r-0">
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          {row.fuelType}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.CO2}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.CH4}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.N2O}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.CO2Equivalent}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.GHG}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.SOX}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.NOX}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                        {row.PM}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Additional information */}
            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
              <p className="text-xs text-blue-700">
                <strong>Note:</strong> Emission factors are expressed in{" "}
                <code>kg per kg of fuel</code>. SOₓ depends on sulfur content
                (S%) in the fuel. Values are based on IMO 4th GHG Study & IPCC
                2006 guidelines.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferenceTable;
